import { Action } from '@ngrx/store';
import { User } from '../../../_models/user';
import { Reason } from '../../../_models/reason';
import { ReasonType } from '../../../_models/reason_type';

export enum ReasonActitonTypes {

  ClearReason = '[Reason] Clear',
  InicializeReason = '[Reason] Inicialize',

  GetCurrentReason = '[Reason] Get Current',
	SetCurrentReason = '[Reason] Set Current',
	SetCurrentReasonId = '[Reason] Set Current Id',

	SetFilterFields = '[Reason] Set Filter Fields',

	LoadReasons = '[Reason] Get List',
	LoadReasonsSuccess = '[Reason] Load Success',
  LoadReasonsFail = '[Reason] Load Fail',

  LoadReasonTypes = '[Reason] Get Type List',
  LoadReasonTypesSuccess = '[Reason] Load Type Success',
  LoadReasonTypesFail = '[Reason] Load Type Fail',

  UpdateReason = '[Reason] Update',
  UpdateReasonSuccess = '[Reason] Update Success',
	UpdateReasonFail = '[Reason] Update Fail',

	CreateReason = '[Reason] Create',
  CreateReasonSuccess = '[Reason] Create Success',
	CreateReasonFail = '[Reason] Create Fail',

	DeleteReason = '[Reason] Delete',
  DeleteReasonSuccess = '[Reason] Delete Success',
	DeleteReasonFail = '[Reason] Delete Fail',

	LoadUsers = '[Reason] Get Users',
	LoadUsersSuccess = '[Reason] Load Users Success',
  LoadUsersFail = '[Reason] Load Users Fail'
}

export class ClearReason implements Action {
	readonly type = ReasonActitonTypes.ClearReason;
}

export class InicializeReason implements Action {
	readonly type = ReasonActitonTypes.InicializeReason;
}

export class GetCurrentReason implements Action {
	readonly type = ReasonActitonTypes.GetCurrentReason;
}

export class SetCurrentReason implements Action {
	readonly type = ReasonActitonTypes.SetCurrentReason;

	constructor(public payload: Reason) {}
}

export class SetCurrentReasonId implements Action {
	readonly type = ReasonActitonTypes.SetCurrentReasonId;

	constructor(public payload: bigint) {}
}

export class SetFilterFields implements Action {
	readonly type = ReasonActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class LoadReasons implements Action {
	readonly type = ReasonActitonTypes.LoadReasons;

	constructor(public payload: any) {}
	// constructor(public payload: {
    //   finished: boolean,
    //   searchDesc: string,
    //   searchName: string
    // }) {}
}

export class LoadReasonsSuccess implements Action {
	readonly type = ReasonActitonTypes.LoadReasonsSuccess;

	constructor(public payload: Reason[]) {}
}

export class LoadReasonsFail implements Action {
	readonly type = ReasonActitonTypes.LoadReasonsFail;

	constructor(public payload: string) {}
}

export class LoadReasonTypes implements Action {
	readonly type = ReasonActitonTypes.LoadReasonTypes;

	constructor(public payload: any) {}
}

export class LoadReasonTypesSuccess implements Action {
	readonly type = ReasonActitonTypes.LoadReasonTypesSuccess;

	constructor(public payload: ReasonType[]) {}
}

export class LoadReasonTypesFail implements Action {
	readonly type = ReasonActitonTypes.LoadReasonTypesFail;

	constructor(public payload: string) {}
}

export class UpdateReason implements Action {
	readonly type = ReasonActitonTypes.UpdateReason;

	constructor(public payload: Reason) {}
}

export class UpdateReasonSuccess implements Action {
	readonly type = ReasonActitonTypes.UpdateReasonSuccess;

	constructor(public payload: Reason) {}
}

export class UpdateReasonFail implements Action {
	readonly type = ReasonActitonTypes.UpdateReasonFail;

	constructor(public payload: string) {}
}

export class DeleteReason implements Action {
	readonly type = ReasonActitonTypes.DeleteReason;

	constructor(public payload: Reason) {}
}

export class DeleteReasonSuccess implements Action {
	readonly type = ReasonActitonTypes.DeleteReasonSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteReasonFail implements Action {
	readonly type = ReasonActitonTypes.DeleteReasonFail;

	constructor(public payload: string) {}
}

export class CreateReason implements Action {
	readonly type = ReasonActitonTypes.CreateReason;

	constructor(public payload: Reason) {}
}

export class CreateReasonSuccess implements Action {
	readonly type = ReasonActitonTypes.CreateReasonSuccess;

	constructor(public payload: Reason) {}
}

export class CreateReasonFail implements Action {
	readonly type = ReasonActitonTypes.CreateReasonFail;

	constructor(public payload: string) {}
}

// ------- AGENTES COMERCIALES --------
export class LoadUsers implements Action {
	readonly type = ReasonActitonTypes.LoadUsers;
}

export class LoadUsersSuccess implements Action {
	readonly type = ReasonActitonTypes.LoadUsersSuccess;

	constructor(public payload: User[]) {}
}

export class LoadUsersFail implements Action {
	readonly type = ReasonActitonTypes.LoadUsersFail;

	constructor(public payload: string) {}
}

// Unión de acciones
export type ReasonActions = ClearReason
| InicializeReason
| GetCurrentReason
| SetCurrentReason
| SetCurrentReasonId
| SetFilterFields
| LoadReasons
| LoadReasonsSuccess
| LoadReasonsFail
| LoadReasonTypes
| LoadReasonTypesSuccess
| LoadReasonTypesFail
| UpdateReason
| UpdateReasonSuccess
| UpdateReasonFail
| CreateReason
| CreateReasonSuccess
| CreateReasonFail
| DeleteReason
| DeleteReasonSuccess
| DeleteReasonFail
| LoadUsers
| LoadUsersSuccess
| LoadUsersFail;
